import React from "react";

function Possibilities() {
  return (
    <div class="possibilities col-12 col-lg-11 ml-lg-5 mt-5">
      <h5>Explorez plus de possibilités</h5>
      <div class="col-12 d-flex flex-wrap p-0">
        <div class="col-12 col-md-3 mb-5">
          <div class="index-icon mb-4">
            <img
              alt="pic"
              src="https://res.cloudinary.com/ghanawifi/image/upload/v1560360099/Group_8_k4gjj5.png"
            />
          </div>
          <div>
            <h5>Téléchargements illimités</h5>
            <p>
              Sans limite d'utilisation mensuelle, vous pouvez télécharger sans
              seuil.
            </p>
          </div>
        </div>

        <div class="col-12 col-md-3 mb-5">
          <div class="index-icon mb-4">
            <img
              alt="pic"
              src="https://res.cloudinary.com/ghanawifi/image/upload/v1560360099/OnlineCourse_jbd5pv.png"
            />
          </div>
          <div>
            <h5>Apprentissage en ligne</h5>
            <p>
              Développez vos compétences ou acquérez un nouveau diplôme avec
              notre internet illimité.
            </p>
          </div>
        </div>

        <div class="col-12 col-md-3 mb-5">
          <div class="index-icon mb-4">
            <img
              alt="pic"
              src="https://res.cloudinary.com/ghanawifi/image/upload/v1560360099/Group_11_m53s7v.png"
            />
          </div>
          <div>
            <h5>Jeux en ligne</h5>
            <p>
              Ne soyez pas retenu par un Internet limité en données. Restez
              connecté, concourez jusqu'à ce que vous gagniez.
            </p>
          </div>
        </div>

        <div class="col-12 col-md-3 mb-5">
          <div class="index-icon mb-4">
            <img
              alt="pic"
              src="https://res.cloudinary.com/ghanawifi/image/upload/v1560360099/HomeSecurity_sfupzc.png"
            />
          </div>
          <div>
            <h5>Sécurité à domicile</h5>
            <p>
              Configurez et maintenez vos systèmes de sécurité opérationnels
              sans interruption en utilisant CIVWifi.
            </p>
          </div>
        </div>

        <div class="col-12 col-md-3 mb-5">
          <div class="index-icon mb-4">
            <img
              alt="pic"
              src="https://res.cloudinary.com/ghanawifi/image/upload/v1560361014/OnlineStream_qg3fyt.png"
            />
          </div>
          <div>
            <h5>Télévision Internet</h5>
            <p>
              Ne manquez jamais aucune de vos émissions de télévision en ligne
              préférées lorsque vous êtes connecté à CivWifi.
            </p>
          </div>
        </div>

        <div class="col-12 col-md-3 mb-5">
          <div class="index-icon mb-4">
            <img
              alt="pic"
              src="https://res.cloudinary.com/ghanawifi/image/upload/v1560360099/Group_9_1_l8ttgo.png"
            />
          </div>
          <div>
            <h5>Commerce électronique</h5>
            <p>
              Naviguez de magasin en magasin et ne manquez jamais une commande
              sur votre plateforme de commerce électronique.
            </p>
          </div>
        </div>

        <div class="col-12 col-md-3 mb-5">
          <div class="index-icon mb-4">
            <img
              alt="pic"
              src="https://res.cloudinary.com/ghanawifi/image/upload/v1560439004/Group_10_2_c2jxnx.png"
            />
          </div>
          <div>
            <h5>Mises à jour de logiciel</h5>
            <p>
              Gardez tous les logiciels à jour et stables en utilisant notre
              Internet illimité par CivWifi.
            </p>
          </div>
        </div>

        <div class="col-12 col-md-3 mb-5">
          <div class="index-icon mb-4">
            <img
              alt="pic"
              src="https://res.cloudinary.com/ghanawifi/image/upload/v1560787628/VideoCalls_asfscp.png"
            />
          </div>
          <div>
            <h5>Appels vidéo</h5>
            <p>
              Restez connecté avec votre famille et vos amis via des appels
              vidéo grâce à notre Internet illimité.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Possibilities;
